import Splide from '@splidejs/splide';

const EL_SELECTOR = '.js-CarouselHomeHero'
const EL = document.querySelector(EL_SELECTOR)

if(EL){
  var splide = new Splide( EL_SELECTOR, {
    type: 'fade',
    rewind: true,
    arrows: false
  } ).mount();

  splide.on( 'move', function (newIndex, prevIndex) {
    const slide = EL.querySelector('.splide__slide:nth-child('+(newIndex + 1)+')')
    const video = slide.querySelector('video')

    if(video) {
      video.play()
    }
  } );

  splide.on( 'moved', function (newIndex, prevIndex) {
    const slide = EL.querySelector('.splide__slide:nth-child('+(prevIndex + 1)+')')
    const video = slide.querySelector('video')

    if(video) {
      video.pause()
    }
  } );
}
